import React from 'react'
import { useSpring, animated as a } from 'react-spring'

import { Box, Input, SVG } from 'system'

export const DocsInput = ({ svg, isError, ...props }) => {
  const animatedProps = useSpring({
    from: { transform: 'translateX(0px)' },
    to: async next => {
      await next({ transform: 'translateX(-8px)' })
      await next({ transform: 'translateX(8px)' })
      await next({ transform: 'translateX(0px)' })
    },
    config: { duration: 75 },
  })

  return (
    <Box
      position="relative"
      width="100%"
      as={a.div}
      style={isError ? animatedProps : null}
    >
      <Input
        width="100%"
        py={2}
        pr={2}
        pl={5}
        mb={2}
        borderRadius="4px"
        border="1px solid"
        borderColor={isError ? 'red.70' : 'purple.90'}
        fontSize="normal"
        css={`
          outline: none;
          transition: background 0.25s ease;

          &:focus,
          &:active {
            background: ${p => p.theme.colors.purple[100]};
          }

          &::placeholder {
            color: ${p => p.theme.colors.gray[60]};
          }
        `}
        {...props}
      />
      <SVG
        x={1}
        y={1}
        svg={svg}
        width="1.25rem"
        color="gray.60"
        fill="transparent"
        position="absolute"
        top="15px"
        left="12px"
      />
    </Box>
  )
}

export default DocsInput
